var _style, _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJeopardyManagementSliderWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 90 90",
    style: {
      enableBackground: "new 0 0 90 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000016074620283449286370000006882137124823701903_);}\n\t.st1{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 90,
    height: 90
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000104691149900890597420000012841685353592955833_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000104691149900890597420000012841685353592955833_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6.2,24.9c0.7,0.4,1.5,0.1,1.9-0.5c0.2-0.4,0.5-0.8,0.7-1.2l-1.5-2.8c-0.6,0.9-1.1,1.7-1.6,2.6 C5.3,23.7,5.5,24.5,6.2,24.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M37.9,3.3c0.1,0,0.2,0,0.2,0c1.3-0.2,2.7-0.4,4-0.5c0.8,0,1.4-0.7,1.3-1.5C43.4,0.5,42.8,0,42,0 c-1.4,0.1-2.9,0.3-4.3,0.5c-0.8,0.1-1.3,0.9-1.2,1.6C36.6,2.8,37.2,3.3,37.9,3.3L37.9,3.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.5,6c0.2,0,0.4,0,0.5-0.1c1.2-0.5,2.5-1,3.8-1.4c0.7-0.2,1.2-1,0.9-1.8c-0.2-0.7-1-1.2-1.8-0.9 c-1.4,0.4-2.8,0.9-4.1,1.4c-0.7,0.3-1.1,1.1-0.8,1.8C27.4,5.6,27.9,6,28.5,6L28.5,6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M88.7,46.3c-0.8,0-1.4,0.5-1.5,1.3c-0.1,1.3-0.2,2.6-0.4,4l0,0.1c-0.1,0.8,0.4,1.5,1.2,1.6 c0.8,0.1,1.5-0.4,1.6-1.2l0-0.1c0.2-1.4,0.4-2.8,0.5-4.2C90,47.1,89.4,46.4,88.7,46.3L88.7,46.3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1.3,43.7c0.8,0,1.4-0.5,1.5-1.3c0.1-1.3,0.2-2.7,0.4-4v0l-1.4-0.2L0.5,38c-0.2,1.4-0.4,2.8-0.5,4.3 C0,43,0.5,43.7,1.3,43.7L1.3,43.7z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2.7,34c0.7,0.2,1.5-0.2,1.8-1c0.4-1.3,0.8-2.6,1.3-3.8c0.3-0.7-0.1-1.5-0.8-1.8c-0.7-0.3-1.5,0.1-1.8,0.8 c-0.5,1.3-1,2.7-1.4,4.1C1.5,33,2,33.8,2.7,34L2.7,34z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M57,4.5c1.3,0.4,2.6,0.8,3.8,1.3c0.7,0.3,1.5-0.1,1.8-0.8c0.3-0.7-0.1-1.5-0.8-1.8c-1.3-0.5-2.7-1-4.1-1.4 c-0.7-0.2-1.5,0.2-1.8,1C55.8,3.5,56.3,4.3,57,4.5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M84.2,29.1c0.5,1.3,1,2.5,1.4,3.8c0.2,0.7,1,1.2,1.8,0.9c0.7-0.2,1.2-1,0.9-1.8c-0.4-1.4-0.9-2.7-1.4-4.1 c-0.3-0.7-1.1-1.1-1.8-0.8C84.2,27.6,83.9,28.4,84.2,29.1L84.2,29.1z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M87.9,36.6c-0.8,0.1-1.3,0.9-1.2,1.6c0.2,1.3,0.4,2.7,0.5,4c0,0.8,0.7,1.4,1.5,1.3c0.8,0,1.4-0.7,1.3-1.5 c-0.1-1.4-0.3-2.9-0.5-4.3C89.4,37,88.7,36.5,87.9,36.6L87.9,36.6z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M81.8,24.2c0.4,0.7,1.2,0.9,1.9,0.5c0.7-0.4,0.9-1.2,0.5-1.9c-0.5-0.8-1-1.7-1.5-2.5l-1.5,2.8 C81.4,23.5,81.6,23.9,81.8,24.2L81.8,24.2z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2.1,53.5c0.8-0.1,1.3-0.9,1.2-1.6c-0.2-1.3-0.4-2.7-0.5-4c0-0.8-0.7-1.4-1.5-1.3C0.5,46.5,0,47.2,0,48 c0.1,1.4,0.3,2.9,0.5,4.3C0.6,53.1,1.3,53.6,2.1,53.5L2.1,53.5z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M47.6,2.8c1.3,0.1,2.7,0.2,4,0.4l0.1,0c0.8,0.1,1.5-0.4,1.6-1.2c0.1-0.8-0.4-1.5-1.2-1.6l-0.1,0 c-1.4-0.2-2.9-0.4-4.3-0.5c-0.8,0-1.4,0.5-1.5,1.3C46.2,2.1,46.8,2.8,47.6,2.8L47.6,2.8z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M65.7,8.2c0.1,0.1,0.2,0.1,0.4,0.2h5C71,8.2,70.9,8.1,70.8,8c-1.2-0.8-2.4-1.6-3.7-2.3 c-0.7-0.4-1.5-0.1-1.9,0.5C64.8,6.9,65,7.8,65.7,8.2C65.7,8.1,65.7,8.1,65.7,8.2L65.7,8.2z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M24.2,8.2c0.7-0.4,0.9-1.2,0.5-1.9c-0.4-0.7-1.2-0.9-1.9-0.5c-1.3,0.7-2.5,1.5-3.7,2.3 c-0.1,0.1-0.2,0.2-0.3,0.3h5.1C24,8.3,24.1,8.3,24.2,8.2L24.2,8.2z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M69.2,79.6c-1.1,0.8-2.3,1.5-3.4,2.2c-0.7,0.4-0.9,1.2-0.5,1.9c0.4,0.7,1.3,0.9,2,0.5c0,0,0.1,0,0.1-0.1 c1-0.6,2-1.2,3-1.9c0.2-0.1,0.3-0.2,0.5-0.3c0.6-0.4,0.8-1.3,0.4-2S69.9,79.2,69.2,79.6L69.2,79.6z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M51.8,86.7c-1.3,0.2-2.7,0.4-4,0.5c-0.8,0-1.4,0.7-1.3,1.5c0,0.7,0.7,1.3,1.4,1.3c0,0,0.1,0,0.1,0 c1.4-0.1,2.9-0.3,4.3-0.5c0.8-0.1,1.3-0.9,1.2-1.6C53.3,87.1,52.6,86.6,51.8,86.7L51.8,86.7z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M76.3,73.4c-0.9,1-1.9,2-2.9,2.9c-0.6,0.5-0.6,1.4-0.1,2c0.5,0.6,1.4,0.6,2,0.1c1.1-1,2.1-2,3.1-3.1 c0.5-0.6,0.5-1.5-0.1-2C77.7,72.8,76.9,72.8,76.3,73.4z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M60.9,84.2c-1.3,0.5-2.5,1-3.8,1.4c-0.7,0.2-1.2,1-0.9,1.8c0.2,0.7,1,1.2,1.8,0.9c1.4-0.4,2.7-0.9,4.1-1.4 c0.7-0.3,1.1-1.1,0.8-1.8C62.5,84.2,61.6,83.9,60.9,84.2L60.9,84.2z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M87.3,56c-0.7-0.2-1.5,0.2-1.8,0.9c-0.4,1.3-0.8,2.6-1.3,3.8c-0.3,0.7,0.1,1.5,0.8,1.8 c0.7,0.3,1.5-0.1,1.8-0.8c0.5-1.3,1-2.7,1.4-4.1C88.5,57,88,56.2,87.3,56L87.3,56z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M83.8,65.2c-0.7-0.4-1.5-0.1-1.9,0.5c-0.7,1.2-1.4,2.3-2.2,3.4c-0.4,0.6-0.3,1.5,0.4,2c0.6,0.4,1.5,0.3,2-0.4 c0.8-1.2,1.6-2.4,2.3-3.7C84.7,66.4,84.5,65.5,83.8,65.2L83.8,65.2z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M24.3,81.9c-1.2-0.7-2.3-1.4-3.4-2.2c-0.6-0.4-1.5-0.3-2,0.4c-0.4,0.6-0.3,1.5,0.4,2c1.2,0.8,2.4,1.6,3.7,2.3 c0.7,0.4,1.5,0.1,1.9-0.5C25.2,83.1,25,82.3,24.3,81.9z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M13.8,73.5c-0.5-0.6-1.4-0.6-2-0.1c-0.6,0.5-0.6,1.4-0.1,2c1,1.1,2,2.1,3.1,3.1c0.6,0.5,1.5,0.5,2-0.1 c0.5-0.6,0.5-1.5-0.1-2C15.7,75.4,14.7,74.5,13.8,73.5z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.2,65.8c-0.4-0.7-1.2-0.9-1.9-0.5c-0.7,0.4-0.9,1.2-0.5,1.9c0.7,1.3,1.5,2.5,2.3,3.7c0.4,0.6,1.3,0.8,2,0.3 c0.6-0.4,0.8-1.3,0.3-2C9.6,68.2,8.9,67,8.2,65.8L8.2,65.8z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5.9,61c-0.5-1.3-1-2.5-1.4-3.8c-0.2-0.7-1-1.2-1.8-0.9c-0.7,0.2-1.2,1-0.9,1.8c0.4,1.4,0.9,2.7,1.4,4.1 c0.3,0.7,1.1,1,1.8,0.8C5.8,62.5,6.1,61.7,5.9,61L5.9,61z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33,85.5c-1.3-0.4-2.6-0.8-3.8-1.3c-0.7-0.3-1.5,0.1-1.8,0.8c-0.3,0.7,0.1,1.5,0.8,1.8c1.3,0.5,2.7,1,4.1,1.4 c0.7,0.2,1.5-0.2,1.8-1C34.2,86.5,33.8,85.8,33,85.5L33,85.5z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M42.4,87.2c-1.3-0.1-2.7-0.2-4-0.4h0c-0.8-0.1-1.5,0.4-1.6,1.2c-0.1,0.8,0.4,1.5,1.2,1.6l0.1,0 c1.4,0.2,2.8,0.4,4.2,0.5c0,0,0.1,0,0.1,0c0.8,0,1.4-0.6,1.4-1.4C43.7,87.8,43.1,87.2,42.4,87.2L42.4,87.2z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48.7,76.6l32.4-59.2c1.1-2,0.4-4.6-1.7-5.8c-0.6-0.3-1.3-0.5-2-0.5H12.6c-2.3,0-4.2,1.9-4.2,4.3 c0,0.7,0.2,1.4,0.5,2l32.4,59.2c1.1,2,3.7,2.8,5.7,1.7C47.7,77.9,48.3,77.3,48.7,76.6z M45,76c-0.5,0-1-0.3-1.2-0.7L11.4,16.1 c-0.2-0.4-0.2-1,0-1.4c0.2-0.4,0.7-0.7,1.2-0.7h64.8c0.5,0,0.9,0.3,1.2,0.7c0.3,0.4,0.3,1,0,1.4L46.2,75.3C46,75.7,45.5,76,45,76 L45,76z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56.3,36.1h-6l2.3-17c0.1-0.8-0.4-1.5-1.2-1.6c-0.6-0.1-1.2,0.2-1.5,0.8L38.1,42.5c-0.3,0.7,0,1.5,0.6,1.9 c0.2,0.1,0.4,0.1,0.6,0.1h5l-3.8,16.3c-0.2,0.8,0.3,1.5,1,1.7c0.6,0.1,1.2-0.1,1.5-0.6l14.4-23.7c0.4-0.7,0.2-1.5-0.5-1.9 C56.8,36.2,56.5,36.1,56.3,36.1L56.3,36.1z M45.3,52.9l2.2-9.4c0.2-0.8-0.3-1.5-1-1.7c-0.1,0-0.2,0-0.3,0h-4.5l7-14.3l-1.4,9.9 c-0.1,0.8,0.4,1.5,1.2,1.6c0.1,0,0.1,0,0.2,0h5.1L45.3,52.9L45.3,52.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJeopardyManagementSliderWhite);
export default __webpack_public_path__ + "static/media/jeopardy-management-slider-white.273d7751e8f34839926f52a08838c019.svg";
export { ForwardRef as ReactComponent };